/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccessCondition } from '../models/AccessCondition';
import { PermissionGrant } from '../models/PermissionGrant';

export class Role {
  /**
  * The ID of the role
  */
  'id': string;
  /**
  * The name of the role
  */
  'name': string;
  /**
  * Whether the role is built in
  */
  'isBuiltInRole': boolean;
  /**
  * The permissions of the role
  */
  'permissionGrants': Array<PermissionGrant>;
  /**
  * The condition of the role
  */
  'accessConditions'?: Array<AccessCondition>;
  /**
  * The scopes of the role
  */
  'scopes': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "isBuiltInRole",
      "baseName": "isBuiltInRole",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "permissionGrants",
      "baseName": "permissionGrants",
      "type": "Array<PermissionGrant>",
      "format": ""
    },
    {
      "name": "accessConditions",
      "baseName": "accessConditions",
      "type": "Array<AccessCondition>",
      "format": ""
    },
    {
      "name": "scopes",
      "baseName": "scopes",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Role.attributeTypeMap;
  }

  public constructor() {
  }
}

